module.exports = __webpack_public_path__ + "static/logo-f8786fddbb3dfe44411108e599a11d74.png";